import {Box, Center, Flex, Icon, Text} from '@chakra-ui/react'
import {ReactComponent as ArrowDownIcon} from '@assets/svgs/arrow_down.svg'
import {ReactComponent as ArrowUpIcon} from '@assets/svgs/arrow_up.svg'
import {Progress} from 'antd'
import {useLocation, useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import {useState} from 'react'

const ItemSentence = ({data, title}: {data: any; title: any}) => {
  const [isShowDetail, setIsShowDetail] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const {entry_point} = location.state || {}

  return (
    <>
      <Box borderRadius={'16px'}>
        <Flex
          borderBottom={'1px solid #E8E8E8'}
          py={'20px'}
          gap={'16px'}
          justifyContent={'space-between'}
          alignItems={'center'}>
          <Flex flexDirection={'column'} flex={1}>
            <Text
              fontSize={{base: '16px', md: '24px'}}
              fontWeight={600}
              color={'#003A8C'}>
              {title}
            </Text>
            <Flex alignItems={'center'} gap={'8px'} mt={'8px'}>
              <Icon
                w={{base: '16px', md: '24px'}}
                h={{base: '16px', md: '24px'}}
                sx={{
                  stroke: '#1890FF',
                }}>
                {isShowDetail ? <ArrowUpIcon /> : <ArrowDownIcon />}
              </Icon>
              <Text
                fontSize={{base: '14px', md: '16px'}}
                color={'#1890FF'}
                cursor={'pointer'}
                w={'fit-content'}
                fontWeight={600}
                onClick={() => setIsShowDetail(!isShowDetail)}>
                {isShowDetail
                  ? 'Ẩn bớt'
                  : `Xem chi tiết ${data?.length || 0} câu`}
              </Text>
            </Flex>
          </Flex>
          <Center
            w={{base: '100px', md: '150px'}}
            h={'40px'}
            borderRadius={'12px'}
            border={'1px solid #ff9400'}
            flexShrink={0}
            color={'white'}
            cursor={'pointer'}
            fontWeight={700}
            bg={'#ff9400'}
            onClick={() =>
              navigate(PATH.LEARN_REVISE_SENTENCE, {
                state: {folderId: data[0]?.data.folder_id, entry_point},
              })
            }>
            Bắt đầu
          </Center>
        </Flex>
      </Box>
      {isShowDetail && (
        <Box>
          {data?.map((item: any, index: any) => (
            <Box
              key={index}
              borderRadius={'16px'}
              cursor={'pointer'}
              _hover={{
                bg: '#E6F7FF',
              }}>
              <Flex
                p={'16px'}
                gap={'16px'}
                justifyContent={'space-between'}
                alignItems={'center'}>
                <Flex flexDirection={'column'} flex={1}>
                  <Flex alignItems={'center'} gap={'8px'}>
                    <Text fontSize={'16px'} color={'#1F1F1F'}>
                      {item.data.question_en}
                    </Text>
                  </Flex>
                  <Text fontSize={'13px'} color={'#8C8C8C'}>
                    {item.data.question_vi}
                  </Text>
                </Flex>
                <Progress
                  type="circle"
                  percent={item.progress_percentage}
                  size={40}
                />
              </Flex>
            </Box>
          ))}
        </Box>
      )}
    </>
  )
}

export default ItemSentence
